export default __webpack_public_path__ + "static/media/mail.68ba9b18.svg";